import React, { useState, useEffect } from 'react'; // 1. Добавили хуки
import { classNames } from 'shared/lib/classNames/classNames';
import { RoutePath } from 'shared/config/routeConfig/routeConfig';
import Logo from 'shared/assets/svg/logoMob.inline.svg';
import { Link } from 'gatsby';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { FormModalButton } from 'features/FormModal';
import * as cls from './Footer.module.css';

interface FooterProps {
  className?: string;
}

export const Footer = (props: FooterProps) => {
    const { className } = props;

    // 2. Создаем состояние для плашки (по умолчанию скрыта)
    const [showConsent, setShowConsent] = useState(false);

    // 3. Проверяем, заходил ли юзер раньше (безопасно для сборщика Gatsby)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isAccepted = localStorage.getItem('cookie-accepted');
            if (!isAccepted) {
                setShowConsent(true);
            }
        }
    }, []);

    // 4. Функция, которая прячет плашку навсегда после клика
    const handleAccept = () => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('cookie-accepted', 'true');
            setShowConsent(false);
        }
    };

    return (
        
  <>
		<footer
            data-scroll-section
            className={classNames(cls.footer, {}, [
                className,
                'pt-8 sm:pt-[4.5625rem] pb-6 sm:pb-[3.4375rem] bg-blue30 dark:bg-bluegrey900',
            ])}
        >
            <div
                data-scroll
                className={classNames(cls.footerContainer, {}, ['container relative'])}
            >
                <div className="relative z-10">
                    <div className="pb-[1.375rem] sm:pb-[1.9375rem] ">
                        <div className="flex flex-col gap-[1.625rem] sm:grid lg:grid-cols-12 sm:gap-5">
                            <Link to={RoutePath.main} className="w-fit block col-span-4">
                                <Logo
                                    className={classNames(cls.logo, {}, [className, 'logo'])}
                                />
                            </Link>
                            <div className="col-span-3">
                                <h6 className="text-13med text-bluegrey400 mb-3 sm:mb-[1.125rem]">
                                    Курсы
                                </h6>
                                <ul className="text-17med flex flex-col gap-[6px] sm:gap-2">
                                    {/* --- ДО --- */}
                                    <li>
                                        <Link to="/directions/svet">Светодизайнер. Архитектурное освещение. Введение в профессию</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/mp_o_prof_do">Менеджер проектных продаж. Введение в профессию</Link>
                                    </li>

                                    {/* --- ПП --- */}
                                    <li>
                                        <Link to="/directions/svet_professional">Светодизайнер</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/manager">Менеджер проектных продаж</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/main_engineer">Главный инженер проекта (ГИП)</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/tender_pp">Специалист по тендерам</Link>
                                    </li>

                                    {/* --- ПК --- */}
                                    <li>
                                        <Link to="/directions/architectual">Архитектурный светодизайн</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/landscape">Ландшафтный светодизайн</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/svetotech">Светотехника</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/prprod_pc">Подготовка к проектным продажам</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/lidogen_pc">Проектные продажи. Лидогенерация</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/coversion_pc">Проектные продажи. Конверсия и переговоры</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/postsales_pc">Постпродажное сопровождение</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/tender_zak">Основы работы с тендерами и закупками</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/tender_sf">Основы участия в тендерах в сфере светодизайна</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/zayavka">Подготовка и подача заявок на ЭТП</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/instruments">Инструменты работы тендерного отдела</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/gip">Основные понятия профессии ГИП. Роль ГИПа в проекте</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/engi_pc">Инженерные изыскания</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/preprojecting">Предпроектные работы. Работа с внешними подрядчиками</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/projecting">Проектная деятельность. Разработка и контроль проектной документации</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/bim">BIM-моделирование</Link>
                                    </li>
                                    <li>
                                        <Link to="/directions/realisation">Реализация и сопровождение проекта. Разработка рабочей документации</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-span-2">
                                <h6 className="text-13med text-bluegrey400 mb-3 sm:mb-[1.125rem]">
                                    О нас
                                </h6>
                                <ul className="text-17med flex flex-col gap-[6px] sm:gap-2">
                                    <li>
                                        <Link to={RoutePath.about}>О школе</Link>
                                    </li>
                                    <li className="sm:col-start-1 sm:row-start-2">
                                        <Link to={RoutePath.contacts}>Контакты</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="sm:col-span-3 hidden sm:block">
                                <FormModalButton
                                    theme={ButtonTheme.PRIMARY}
                                    text="Записаться на курс"
                                    className="mb-4 lg:ml-auto"
                                    to="/"
                                />
                            </div>
                        </div>
                        <div className="mt-4 sm:mt-[6.0625rem] sm:grid sm:grid-cols-12 sm:gap-5">
                            <div className="col-span-6 justify-self-end tye sm:text-end flex">
                                <div className="mt-auto">
                                    <a
                                        className="text-17semi sm:text-20bold"
                                        itemProp="url"
                                        href="tel:+79362552602"
                                    >
                                        +7(936)255-26-02
                                    </a>
                                    <p className="text-13med text-bluegrey400 text-13med">
                                        Контактный центр
                                    </p>
                                </div>
                            </div>
                            <div className="col-span-2 text-15med col-start-5 row-start-1 h-fit mt-[0.8125rem] sm:mt-auto ">
                                <Link
                                    className="text-blueGrey900 hover:text-blue700 transition-colors"
                                    to={RoutePath.sitemap}
                                >
                                    Карта сайта
                                </Link>
                            </div>
                            <div className="col-start-1 row-start-1 col-span-4 sm:grid ">
                                <a
                                    className="text-15semi sm:text-17med mt-[0.8125rem] sm:mt-[0.9375rem] block w-fit sm:row-start-3"
                                    itemProp="url"
                                    href="mailto:school@edu.svet-expert.com"
                                >
                                    school@edu.svet-expert.com
                                </a>
                                <p className="text-13med sm:text-17med mt-6 sm:mt-[0.3125rem]">
                                    111024, г. Москва, вн. тер. г. муниципальный округ Лефортово, ш. Энтузиастов, д. 22/18, помещ. 4П
                                </p>
                                <Link
                                    to={RoutePath.contacts}
                                    className="text-15reg sm:text-17med pb-[1px] border-b border-dashed border-bluegrey400 nt-4 sm:mt-1 block w-fit transition-colors hover:text-blue600 hover:border-blue600"
                                >
                                    Показать на картах
                                </Link>
                            </div>
                        </div>
                        <Button
                            text="Записаться на курс"
                            className=" sm:!hidden mt-[22px]"
                            to="/"
                        />
                    </div>
                    <div className="pt-[1.4375rem] border-t border-bluegrey200 sm:border-blue200 sm:grid grid-cols-12 gap-x-5">
                        <ul className="flex gap-2 sm:gap-x-4 sm:gap-y-[0.875rem] flex-col sm:flex-row sm:flex-wrap text-13med col-span-7 max-w-[570px] h-fit mb-[2.125rem]">
                            <li>
                                <Link to={RoutePath.policy} itemProp="url">
                                    Политика обработки персональных данных
                                </Link>
                            </li>
                            <li>
                                <Link to={RoutePath.termofuse} itemProp="url">
                                 Согласие на обработку персональных данных
                                </Link>
                            </li>
						                            <li>
                                <Link to="/cookies/" itemProp="url">
                                  	Согласие на обработку файлов cookie
                                </Link>
                            </li>	
							
						
                            <li>
                                <a href="/" itemProp="url">
                                    Оплата
                                </a>
                            </li>
                            <li>
                                <a href="/" itemProp="url">
                                    Оферта
                                </a>
                            </li>
                            <li>
                                <Link
                                    to={`${RoutePath.inform}/#legal-information`}
                                    itemProp="url"
                                >
                                    Правовая информация
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${RoutePath.inform}/#basic-information`}
                                    itemProp="url"
                                >
                                    Сведения об образовательной организации
                                </Link>
                            </li>
                        </ul>
                        <div className="text-13med flex flex-col gap-[1.125rem] col-span-5 row-span-2">
                            <p>
							Оставаясь на сайте, вы даете Согласие использование файлов cookie. Запретить обработку <a href="/cookies/">cookies</a> можно в настройках вашего браузера
                               
                            </p>
                            <a href="https://minobrnauki.gov.ru/" itemProp="url" className="transition-colors hover:text-blue700">
                                Сайт Минобрнауки России
                            </a>
                            <a href="https://edu.gov.ru/" itemProp="url" className="transition-colors hover:text-blue700">
                                Сайт Минпросвещения России
                            </a>
                            <p>Правообладатель ПО LMS «Angels school» ООО «Энжелс скул».</p>
                        </div>

                        <div className="text-15med text-bluegrey400 col-span-6 h-fit mt-[1.875rem] sm:mt-auto">
                            <a href="https://e.lanbook.com/" target="_blank" rel="noreferrer">
                                <img alt="ЭБС Лань" src="https://e.lanbook.com/front/assets/spa/images/pages/marketing-materials/ebs/88x31.jpg" />
                            </a>
                            <p className="mt-3">
                                с. Angels school, 2026
                            </p>
                        </div>
                    </div>
                </div>
            </div>
			

			
			
        </footer>					  {/* Безопасное всплывающее окно Cookie */}
            {showConsent && (
                <div style={{
                    position: 'fixed',
                    bottom: '24px',
                    left: '24px',
                    right: '24px',
                    maxWidth: '480px',
                    zIndex: 10000,
                    background: '#1E293B', 
                    color: '#F8FAFC',
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                }}>
                    <div>
                        Мы используем cookies-файлы и сервисы аналитики для улучшения работы сайта и персонализации запросов пользователей. Оставаясь на сайте, вы даете{' '}
                        <Link to="/cookies/" style={{ color: '#38BDF8', textDecoration: 'underline' }}>
                            Согласие на использование файлов cookie. 
                        </Link>
                         &nbsp; Запретить обработку cookies можно в настройках вашего браузера. <br/>
						
						 <Link to="/policy/" style={{ color: '#38BDF8', textDecoration: 'underline' }}>
                           Подробнее
                        </Link>
                    </div>
                    <button 
                        onClick={handleAccept}
                        style={{
                            alignSelf: 'flex-end',
                            background: '#38BDF8', 
                            color: '#0F172A',
                            border: 'none',
                            padding: '6px 20px',
                            borderRadius: '6px',
                            fontWeight: '600',
                            cursor: 'pointer',
                        }}
                    >
                        Принять
                    </button>
                </div>
            )}  </>
    );
};
